import React from 'react';

const EditNodeRefetchContext = React.createContext<() => void>(() => {});

export default EditNodeRefetchContext;
